import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../Action";
// import Select from "react-select";
import { bindActionCreators } from "redux";
import SelectComp from'../../NewComponent/Select/Select';

export default function SelectComponentForOverview() {
  const userState = useSelector((state) => state.user);
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
  // console.log(expertOverview,'check expert overview')
  const dispatch = useDispatch();
  const { getActionValue, getTotalCount, getActionName } = bindActionCreators(
    Actions,
    dispatch
  );

  const array1 = Object.entries(userState.auditActions).map(([label, value], index) => {
    let result = {
      label,
      value: value === 0 ? index + 1000 : value,
    };
    if (value === 0) {
      result.id = value;
    }
    return result;
  });
  
  const trendingSearch = array1.filter((item) => item.value === 59);

  const maxLength = Math.max(...array1.map((option) => option.label.length));
  const calculatedWidth = `${maxLength * 8}px`; 

  const customStyles = {
    control: (base, state) => ({
      ...base,
      fontSize: 13,
      marginBottom: 5,
      minHeight: 32,
      height: 32,
      border: "1px solid lightgrey",
      boxShadow: "none",
      // minWidth: calculatedWidth,
      // maxWidth: calculatedWidth,
      "&:hover": { border: "1px solid lightgrey" },
    }),
    menu: (base) => ({
      ...base,
      minWidth: calculatedWidth,
      maxWidth: calculatedWidth,
    }),
    menuList: (base) => ({
      ...base,
      fontSize: 13,
      padding: 0,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected && "var(--viz_light_color)",
      "&:hover": { backgroundColor: state.isSelected ? null : "#ececec" },
      cursor: "pointer",
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      paddingTop: 0,
      paddingBottom: 0,
      color: "lightgray",
    }),
    clearIndicator: (styles) => ({
      ...styles,
      paddingTop: 0,
      paddingBottom: 0,
      color: "lightgray",
    }),
  };

  const onChangeData = (data) => {
    // console.log(data,'check what data is going')
    // let newObj = {...data, id:data?.value}
    // getActionName(newObj?.label);
    // getActionValue(newObj);
    // getTotalCount();
    if(data?.value > 1000)
    {
      let newObj = {...data,id:0}
      getActionName(newObj?.label);
      getActionValue(newObj);
    }
    else{
      getActionName(data?.label)
      getActionValue(data)
    }
     getTotalCount();
  };

  return (
    <div>
      {/* <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={trendingSearch[0]}
        isDisabled={false}
        isClearable={false}
        isSearchable={true}
        name="color"
        options={array1}
        styles={customStyles}
        getOptionValue={(option) => option.id} // Use unique ID for identification
        getOptionLabel={(option) => option.label} // Display the label
        onChange={onChangeData}
      /> */}
      <SelectComp isString={false} val={expertOverview.actionValue} labelInValue={true} width={'100%'} onChangeFunc={onChangeData} options={array1} />
    </div>
  );
}
